export default "__VITE_ASSET__DRqw0Vdr__"